import { createUseStyles } from 'react-jss'
import { blue, lightBlue, mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: 30,
    marginBottom: 46
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8
  },
  number: {
    maxWidth: 25,
    maxHeight: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    padding: '4px 8px',
    background: mediumGrey,
    border: `1px solid ${mediumGrey}`,
    borderRadius: '50%'
  },
  activeStyle: {
    backgroundColor: lightBlue,
    borderColor: blue,
    color: mediumGrey
  }
})

export default useStyles
